@if (isShowPrivacy) {
  <div class="privacy-wrapper" (scroll)="isReadEverything($event, 'PRIVACY')">
    <div [innerHTML]="srcPrivacy"></div>
  </div>
}

@if (isShowEULA) {
  <div class="privacy-wrapper" (scroll)="isReadEverything($event, 'EULA')">
    <div [innerHTML]="srcEULA"></div>
  </div>
}

@if (mode === privacyModesEnum.info) {
  <div class="width-100 display-flex justify-center">
    <button class="blue-rounded-button new-farm-button" (click)="goToLogin()">{{'LOGIN.FORM.to_login' | translate}}</button>
  </div>
}

@if (mode === privacyModesEnum.invite) {
  <div class="width-100 display-flex justify-center">
    <button class="blue-rounded-button new-farm-button" (click)="goToLogin()">{{'LOGIN.FORM.to_invite' | translate}}</button>
    @if (isShowPrivacy) {
      <button class="blue-rounded-button new-farm-button"  [disabled]="!isReadAllPRIVACY"  (click)="acceptPrivacy()">{{'LOGIN.FORM.accept_privacy' | translate}}</button>
    }
    @if (isShowEULA) {
      <button class="blue-rounded-button new-farm-button" [disabled]="!isReadAllEULA" (click)="acceptEULA()">{{'LOGIN.FORM.accept_eula' | translate}}</button>
    }
  </div>
}
